import { TeApiContext } from '@ecommerce/nest-ssr/common';
import Box from 'atomic/box';
import Container from 'atomic/container';
import classNames from 'classnames';
import React, { useContext } from 'react';
import ProducerInterface from 'modules/producers/interfaces/producer.interface';
import { ProducerTabInterface } from 'modules/producers/interfaces/producer-tab.interface';
import { getProducerMainPageUrlBySlug, getProducerTabUrl } from 'modules/producers/helpers/producer-urls';
import Icon from 'atomic/icon/icon';
import scrollTop from 'helpers/scroll-page';

import './producer-tab-menu.scss';

interface ProducerTabProps {
    producer: ProducerInterface;
    producerTab?: ProducerTabInterface;
    isMobile?: boolean;
}

const ProducerTabMenu: React.FC<ProducerTabProps> = ({
    producer,
    producerTab,
    isMobile = false
}) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <Box
            className={classNames({
                'producer-tab-menu': true,
                'producer-tab-menu--mobile': isMobile
            })}
        >
            <Container className="producer-tab-menu__container">
                <div className="producer-tab-menu__list">
                    <a
                        href={getProducerMainPageUrlBySlug(producer.slug)}
                        className={classNames({
                            'producer-tab-menu__list__item': true,
                            'producer-tab-menu__list__item--active': !producerTab,
                            'mobile': api.getDevice() !== 'desktop'
                        })}
                        key={producer.id}
                    >
                        {producer.name}
                    </a>
                    {producer?.tabs?.map((tab) => (
                        <a
                            href={getProducerTabUrl(producer.slug, tab.slug)}
                            className={classNames({
                                'producer-tab-menu__list__item': true,
                                'producer-tab-menu__list__item--active': producerTab ? producerTab.slug === tab.slug : false,
                                'mobile': api.getDevice() !== 'desktop'
                            })}
                            key={tab.slug}
                        >
                            {tab.title}
                        </a>
                    ))}
                </div>
                {api.getDevice() === 'desktop' && (
                    <div className="producer-tab-menu__scroll-top">
                        <Icon
                            name="top"
                            color="secondary"
                            size={26}
                            onClick={scrollTop}
                        />
                    </div>
                )}
            </Container>
        </Box>
    );
};

export default ProducerTabMenu;
